// Used for challenges only — students without a study group send this ID
// when uploading files or submitting quiz answers.
export const CHALLENGE_VIRTUAL_STUDY_GROUP_ID = '9ec75b18-0396-4b2f-ae26-1cd94aa770a6';
